<template>
  <div class="survey-question">
    <h2 class="text-neutral-900 mb-7">{{ question.title }}</h2>
    <component
      v-model="answer"
      v-bind="componentProps"
      :is="questionComponent"
    />
  </div>
</template>

<script>
import QuestionAlternatives from "./QuestionAlternatives.vue";
export default {
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      answer: this.value
    };
  },
  computed: {
    questionComponent() {
      const types = {
        subjective: "bp-input",
        multiple_choice: QuestionAlternatives,
        select_one: "bp-select"
      };
      return types[this.question.type];
    },
    componentProps() {
      return {
        subjective: {
          placeholder: "Digite sua resposta"
        },
        multiple_choice: {
          options: this.question.answer_options || []
        },
        select_one: {
          options: (this.question.answer_options || []).map(({ title }) => ({
            id: title,
            name: title
          })),
          placeholder: "Selecione uma opção"
        }
      }[this.question.type];
    }
  },
  watch: {
    answer(v) {
      this.$emit("input", v);
    },
    value(v) {
      this.answer = v;
    }
  }
};
</script>
